/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */

import { getObjectInfoID } from '../common-helper';
import type { Action } from '../../store/state/state-manager';
import type { DxAPIResponseObject } from '../../case/types';

const getPayloadForEndOfAssignmentProcessingEvent = (
  translatedDXAPIResponse: DxAPIResponseObject,
  actionInPayload: Action['payload']
) => {
  const { isCaseWideAction } = actionInPayload;

  return {
    isCaseWideAction,
    caseID: getObjectInfoID(translatedDXAPIResponse)
  };
};

export default getPayloadForEndOfAssignmentProcessingEvent;
